import React from "react";
import "./Contact.css";
import "aos/dist/aos.css";

const Contactus = () => {
  return (
    <div className="main-body">
      <div className="container">
        <div className="contact-main">
          <div className="contact-content">
            <div className="text-align">
              <h4>Have any Query?</h4>
              <h2>Contact Me</h2>
            </div>
            <div className="row contact-row">
              <div className="col-lg-4 col-md-4 col-sm-12">
                <div className="contact-box">
                  <h5>
                    {" "}
                    <i class="fas fa-map-marker-alt"></i> Locate me
                  </h5>
                  <p>Sheikh Sindhi Hostel MUET</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12">
                <div className="contact-box">
                  <h5>
                    {" "}
                    <i class="fas fa-phone-alt"></i> Give me a Call
                  </h5>
                  <p>+92 3103152377</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12">
                <div className="contact-box">
                  <h5>
                    {" "}
                    <i class="fas fa-envelope"></i> Mail me
                  </h5>
                  <p>aviluhana@gmail.com</p>
                </div>
              </div>
            </div>
            <form onSubmit={null}>
              <div className="contact-form">
                <div className="row form-row">
                  <div className="col-lg-6 col-sm-12">
                    <input
                      type="text"
                      placeholder="Your Name"
                      className="first-input"
                    />
                  </div>
                  <div className="col-lg-6 col-sm-12">
                    <input
                      type="email"
                      placeholder="Your Email"
                      className="first-input"
                    />
                  </div>
                </div>
                <div className="row">
                  <input
                    type="text"
                    placeholder="Your Subject"
                    className="subject"
                  />
                </div>
                <div className="row">
                  <input
                    type="textarea"
                    placeholder="Your Message"
                    className="text-area"
                  />
                </div>
                <button className="submit-button">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    //
  );
};

export default Contactus;
